export * from './icons.component';
export * from './icons.options';
export * from './icons-full.component';
